import AllLockerAssignContainer from './AllLockerAssignContainer'

const AllLockerAssign = () => {
  return (
    <div className='page-body'>
      <AllLockerAssignContainer />
    </div>
  )
}

export default AllLockerAssign